import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

  showMenu = true;

  constructor(private router: Router) { }

  public switchMenu(open: boolean): void {
      this.showMenu = !this.showMenu;
    }
}

